import { render, staticRenderFns } from "./ChatMessageAudioComponent.vue?vue&type=template&id=102b9bb2&scoped=true&"
import script from "./ChatMessageAudioComponent.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageAudioComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessageAudioComponent.vue?vue&type=style&index=0&id=102b9bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102b9bb2",
  null
  
)

export default component.exports